import React, { useState } from "react";
import classNames from "classnames";
import { flow } from "lodash";
import { intl } from "@fidget/common/i18n/TypedIntl";
import styles from "./listDeleteAction.css";

interface Props {
  onDelete(): void;
}
export const ListDeleteAction = ({ onDelete }: Props) => {
  const [isDeleting, setIsDeleting] = useState(false);

  const reset = () => setIsDeleting(false);
  const handleDelete = flow(reset, onDelete);

  const renderOptionsMenu = () => {
    return (
      <div className={styles["options-container"]}>
        <span className={styles["margin-right"]}>{intl.formatMessage("deleteInfinitive")}?</span>
        <span className={styles.option} onClick={reset}>
          {intl.formatMessage("no")}
        </span>
        <span className={styles["margin-small"]}>/</span>
        <span className={styles.option} onClick={handleDelete}>
          {intl.formatMessage("yes")}
        </span>
      </div>
    );
  };

  return (
    <div className={styles.container}>
      {isDeleting ? (
        renderOptionsMenu()
      ) : (
        <i
          className={classNames("icon-trash-dashboard", styles.icon)}
          onClick={() => setIsDeleting(true)}
        />
      )}
    </div>
  );
};
